<template>
    <section class="export-generic-entities-index">
        <div class="col-md-12">
            <pim-header header="Export Sku Tags"></pim-header>

            <transition name="vue-table-loader">
                <div class="vue-table-loader" v-if="isLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
            </transition>

            <div class="card panel panel-default">
                <div class="card-block">
                    <form action="">
                        <input type="hidden" name="_token" :value="csrfToken">
                        <div class="row">
                            <div class="col-md-6">
                                <button v-on:click="exportSkuTags()" type="button" class="btn btn-primary">Export</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/javascript">
    var base_url = window.location.protocol + "//" + window.location.host

    import Vue from 'vue';
    import VueEvents from 'vue-events';
    import axios from 'axios';

    import PimHeader from '../generic/pim-header';

    Vue.use(VueEvents)

    export default {
        name: 'export-sku-tags',
        props: ['csrfToken'],
        components: {
            'pim-header': PimHeader,
        },
        data() {
            return {
                isLoading: false,
                alert: {
                    message: "",
                    status: "alert-success",
                    timeOut: 15000,
                },
            }
        },
        methods: {
            exportSkuTags: function () {

                this.isLoading = true;

                axios.post(base_url + '/export-sku-tags', {})
                .then(function() {
                    this.alert.status = "alert-success";
                    this.alert.message = 'Success, export initiated, we are redirecting you to the Jobs page.';
                    setTimeout(function() {
                        window.location = "/jobs";
                    }, 2000);
                }.bind(this))
                .catch(function (error) {
                    this.alert.status = "alert-danger";
                    this.alert.message = error.response.data.message || 'There was an error, please try again later.';
                }.bind(this))
                .finally(function() {
                    this.isLoading = false;
                }.bind(this));
            },
        }
    };
</script>
